import { Button, Empty } from "antd";
import { Heading } from "components/Heading";
import { useCallback } from "react";
import { useNavigate } from "react-router";

export const NotFound: React.FC<{
  title: string;
  backButton: {
    label: string;
    navigateTo: string;
  };
}> = ({ title, backButton: { label, navigateTo } }) => {
  const navigate = useNavigate();
  const navigateToHome = useCallback(
    () => navigate(navigateTo),
    [navigate, navigateTo]
  );
  return (
    <>
      <Heading title={title} />
      <Empty
        description={
          <>
            <Button type="primary" onClick={navigateToHome}>
              {label}
            </Button>
          </>
        }
      />
    </>
  );
};
